export const TEST_ID = 'maintenanceIcon';
